import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Loading, Toast } from '../../components';
import { loginUser, loginWithDNI } from '../../redux/actions/userActions';
import { INFORMATION_PATH, REGISTER_PAGE_PATH } from '../../routes/path';
import './index.scss';

const LoginScreen = () => {
  const [form, setForm] = useState({
    identificador: '',
    password: '',
    dni: '',
  });

  const [isLoginFormValid, setIsLoginFormValid] = useState({
    identificador: true,
    dni: false,
    password: true,
  });

  const [isDNI, setIsDNI] = useState(true);
  const { isLoggedIn, error, isLoadingUser } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      if (state?.currentPath) {
        navigate(state.currentPath);
      } else {
        navigate(INFORMATION_PATH);
      }
    }
  }, [isLoggedIn]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (isDNI) {
      dispatch(loginWithDNI({ dni: form.dni }));
    } else {
      dispatch(loginUser({ identificador: form.identificador, password: form.password }));
    }
  };

  const handleDNI = (value) => {
    setIsDNI(value);
  };

  const handleRegisterClick = () => {
    navigate(REGISTER_PAGE_PATH);
  };

  const textForms = {
    title: 'Iniciar sesión',
    firstButton: 'Iniciar sesión',
    secondButton: 'Registrarse',
  };

  const formLogin = [{
    type: 'text',
    id: 'identificador',
    text: 'Email',
  }, {
    type: 'password',
    id: 'password',
    text: 'Contraseña',
  }];

  if (isLoadingUser) return <Loading />;

  return (
    <div className="login">
      <Toast error={error} isDNI={isDNI} />
      <Form
        handleSubmit={handleLogin}
        formData={formLogin}
        form={form}
        setForm={setForm}
        textForms={textForms}
        handleClick={handleRegisterClick}
        handleDNI={handleDNI}
        isLogin
        isDNI={isDNI}
        isLoginFormValid={isLoginFormValid}
        setIsLoginFormValid={setIsLoginFormValid}
      />
    </div>
  );
};

export default LoginScreen;
